import { render, staticRenderFns } from "./MoreInfoBlock.vue?vue&type=template&id=68dece9a&"
import script from "./MoreInfoBlock.vue?vue&type=script&lang=js&"
export * from "./MoreInfoBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports